/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { useParams } from 'react-router-dom';
import { Loader } from '@g17eco/atoms/loader';
import NotAuthorised from '../not-authorised';
import { useAppSelector } from '../../reducers';
import { isStaff } from '../../selectors/user';
import { CompanyTableContainer } from './CompanyTableContainer';
import { SponsorCompaniesContainer, SponsorMode } from './SponsorCompaniesContainer';
import { useGetPortfolioCompaniesQuery } from '@api/portfolio-tracker';
import './styles.scss';

export const CompanyManagement = () => {
  const {portfolioId, page, view = SponsorMode.Email } = useParams<{ [key: string]: string }>();

  const isUserStaff = useAppSelector(isStaff);
  const { data: companies = [], isError, isLoading, refetch } = useGetPortfolioCompaniesQuery({ portfolioId }, { skip: !portfolioId });

  if (!portfolioId) {
    return <Loader />;
  }

  if (!isUserStaff || isError) {
    return <NotAuthorised />;
  }

  if (page === 'invite') {
    return <SponsorCompaniesContainer portfolioId={portfolioId} view={view as SponsorMode} handleReload={() => refetch()} />
  }

  return <CompanyTableContainer portfolioId={portfolioId} companies={companies} isLoadingCompanies={isLoading} handleReload={() => refetch()} />;
};
